import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const SubscriptionRequired = () => {
  const { openSubscriptionPage, forceCheckSubscription, isLoading } = useAuth();
  const [isChecking, setIsChecking] = useState(false);

  const handleCheckStatus = async () => {
    setIsChecking(true);
    try {
      await forceCheckSubscription();
    } catch (error) {
      console.error('Error checking subscription status:', error);
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-slate-950">
      <div className="bg-slate-900 border border-white/10 rounded-xl p-8 max-w-md">
        <h2 className="text-xl font-medium text-slate-200 mb-4 text-center">Subscription Required</h2>
        <p className="text-slate-400 mb-6 text-center">
          You need an active subscription to access Quer.
        </p>
        
        <div className="space-y-4">
          <button
            onClick={openSubscriptionPage}
            className="w-full px-4 py-2 bg-gradient-to-b from-amber-500 to-primary-orange text-white text-sm font-medium rounded-lg transition-all shadow-lg hover:opacity-90"
            disabled={isLoading}
          >
            Get Subscription
          </button>
          
          <button
            onClick={handleCheckStatus}
            className="w-full px-4 py-2 bg-slate-800 text-slate-300 text-sm font-medium rounded-lg transition-all hover:bg-slate-700 disabled:opacity-50"
            disabled={isChecking || isLoading}
          >
            {isChecking ? 'Checking...' : 'Check Subscription Status'}
          </button>
        </div>
        
        <p className="text-xs text-slate-500 mt-4 text-center">
          Already subscribed? Click "Check Subscription Status" to refresh.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionRequired;
